import type { R2BStagingBrandEntity } from "../../entity_types/r2bStagingBrand";

export const r2b_staging_woon: R2BStagingBrandEntity = {
  token: "r2b_staging_woon",
  type: "r2bStagingBrand",
  name: "Woon",
  avatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/58e0988461b76b0725bd240221b6e07fb7f6c0f355df5323f7a650031ab9f9d6.png",
  productImageUrls: [
    "https://cdn.prerelease.faire.dev/fastly/58e0988461b76b0725bd240221b6e07fb7f6c0f355df5323f7a650031ab9f9d6.png",
    "https://cdn.prerelease.faire.dev/fastly/9884fdde5b4b4c2aa26c99febaa7f82d0c64c73beee6f184addfb2ac913f7859.png",
    "https://cdn.prerelease.faire.dev/fastly/b8d11f4bfd773d9587388d07a8d7e3ae462e0e2d0fa044680f88bde37f94468f.png",
    "https://cdn.prerelease.faire.dev/fastly/3e9d69ea8313288c957b3ca024de7911d167ae7c79f188e801c89a856b6a09b5.png",
    "https://cdn.prerelease.faire.dev/fastly/6f1e8487f553374ecb578acd93b1a5012cc7429512516eda00d656f0cdeeb503.png",
    "https://cdn.prerelease.faire.dev/fastly/4284b676e76aa12c9f11473e6c3c82e6be32522ff7cdbfbcefe59951d37c17bd.png",
    "https://cdn.prerelease.faire.dev/fastly/d1c38d6d08081673c6515aaffc669ac63b1b8852c550864e450f0bfe75519b51.png",
    "https://cdn.prerelease.faire.dev/fastly/734f3e99a1bd587a6053e69dd1331210037bcdeb137167a20971ea6a83062111.png",
    "https://cdn.prerelease.faire.dev/fastly/fd3d710ef1b00e98253d2e76765c2cb111c43daac1870e05e581857ef0c3ccd1.webp",
    "https://cdn.prerelease.faire.dev/fastly/9007fa5f19edc20337cc2b2748b73ad3e9fb59ee1eacb1e6e01022ca23bea977.webp",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
